'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportPeriods = exports.recipientTabs = exports.coverageTabs = exports.projectTabs = exports.coverageRecipientsColumnsArray = exports.coverageRecipientsColumns = exports.defaultDetailedData = exports.defaultGeographyData = exports.defaultDevicesData = exports.defaultChartData = exports.pageLimit = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _toPairs2 = require('lodash/toPairs');

var _toPairs3 = _interopRequireDefault(_toPairs2);

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _round2 = require('lodash/round');

var _round3 = _interopRequireDefault(_round2);

var _reverse2 = require('lodash/reverse');

var _reverse3 = _interopRequireDefault(_reverse2);

var _keyBy2 = require('lodash/keyBy');

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _clamp2 = require('lodash/clamp');

var _clamp3 = _interopRequireDefault(_clamp2);

var _capitalize2 = require('lodash/capitalize');

var _capitalize3 = _interopRequireDefault(_capitalize2);

exports.processStatsViewer = processStatsViewer;
exports.processStatsViewers = processStatsViewers;
exports.processPopularityData = processPopularityData;
exports.processGeographyCountriesData = processGeographyCountriesData;
exports.processGeographyCitiesData = processGeographyCitiesData;
exports.processDevicesData = processDevicesData;
exports.processRecipientGlobalData = processRecipientGlobalData;
exports.processCoverageData = processCoverageData;
exports.processPlayStatsData = processPlayStatsData;
exports.getOrderedCoverageData = getOrderedCoverageData;
exports.processProjectInfo = processProjectInfo;
exports.processRecipientDetailedData = processRecipientDetailedData;
exports.processTracksDetailsData = processTracksDetailsData;
exports.processRecipientProjects = processRecipientProjects;
exports.processRecipientProjectsPlayStats = processRecipientProjectsPlayStats;

var _strings = require('helpers/strings');

var _datetime = require('helpers/datetime');

var _ordering = require('utils/ordering');

var _ordering2 = _interopRequireDefault(_ordering);

var _projects = require('helpers/projects');

var _countryCodes = require('utils/country-codes');

var _countryCodes2 = _interopRequireDefault(_countryCodes);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var daySeconds = 3600 * 24;

var pageLimit = exports.pageLimit = 100;
var defaultChartData = exports.defaultChartData = { data: [], hasData: false };
var defaultDevicesData = exports.defaultDevicesData = { devices: [], sources: [] };
var defaultGeographyData = exports.defaultGeographyData = { plays: [], downloads: [] };
var defaultDetailedData = exports.defaultDetailedData = { tracks: {}, timings: [] };
var coverageRecipientsColumns = exports.coverageRecipientsColumns = {
  recipientId: 'recipientId',
  fullName: 'fullName',
  email: 'email',
  downloaded: 'downloaded',
  expiryDate: 'expiryDate',
  details: 'details',
  info: 'info',
  share: 'share'
};
var coverageRecipientsColumnsArray = exports.coverageRecipientsColumnsArray = (0, _values2.default)(coverageRecipientsColumns);

var projectTabs = exports.projectTabs = {
  my: 'my',
  available: 'available'
};

var coverageTabs = exports.coverageTabs = {
  played: 'played',
  notAccessed: 'not accessed'
};

var recipientTabs = exports.recipientTabs = {
  info: 'file info',
  detailed: 'detailed action'
};

var reportPeriods = exports.reportPeriods = {
  week: 'week',
  month: 'month',
  custom: 'custom'
};

function processStatsViewer(viewer) {
  var result = (0, _extends4.default)({}, viewer);
  result.fullName = (0, _strings.concat)(' ', viewer.name, viewer.surname);
  return result;
}

function processStatsViewers(viewers) {
  return viewers.map(processStatsViewer);
}

function processPopularityData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return [].concat((0, _toConsumableArray3.default)(data)).map(function (item) {
    item.avgPlaytime = (0, _clamp3.default)((0, _round3.default)(item.avgPlaytime, 2), 0, Infinity);
    item.avgPlaytimeString = (0, _datetime.secToMinString)(item.avgPlaytime);
    item.avgPlaytimeDate = new Date(item.avgPlaytime * 1000);
    return item;
  });
}

function processStatsData(_ref) {
  var stats = _ref.stats,
      getName = _ref.getName,
      getValue = _ref.getValue,
      _ref$replaceEmpty = _ref.replaceEmpty,
      replaceEmpty = _ref$replaceEmpty === undefined ? null : _ref$replaceEmpty,
      notEmpty = _ref.notEmpty;

  var hasData = false;
  var processedData = [];
  (0, _toPairs3.default)(stats).map(function (stat) {
    var _stat = (0, _slicedToArray3.default)(stat, 2),
        name = _stat[0],
        value = _stat[1];

    var resultName = getName ? getName(name) : name;
    var resultValue = getValue ? getValue(value) : value || replaceEmpty;
    if (resultValue) {
      hasData = true;
    }
    if (notEmpty && resultValue || !notEmpty) {
      processedData.push([resultName, resultValue]);
    }
  });

  return { data: processedData, hasData: hasData };
}

function processGeographyCountriesData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { plays: {}, downloads: {} };

  var getName = function getName(name) {
    return _countryCodes2.default[name];
  };
  var getValue = function getValue() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return value.count || 0;
  };

  return {
    plays: processStatsData({ stats: data.plays, getName: getName, getValue: getValue, notEmpty: true }),
    downloads: processStatsData({ stats: data.downloads, getName: getName, getValue: getValue, notEmpty: true })
  };
}

function processGeographyCitiesData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { plays: {}, downloads: {} };

  var mapCities = function mapCities(stats) {
    var citiesStats = [];
    var hasData = false;
    (0, _values2.default)(stats).forEach(function (countryStats) {
      var cities = !(0, _isEmpty3.default)(countryStats.cities) ? countryStats.cities : {};
      (0, _entries2.default)(cities).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            city = _ref3[0],
            count = _ref3[1];

        if (count) {
          hasData = true;
          citiesStats.push([city, count]);
        }
      });
    });
    return { data: citiesStats, hasData: hasData };
  };

  return {
    plays: mapCities(data.plays),
    downloads: mapCities(data.downloads)
  };
}

function processDevicesData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { devices: {}, sources: {} };

  return {
    devices: processStatsData({ stats: data.devices }),
    sources: processStatsData({ stats: data.sources })
  };
}

function processRecipientGlobalData() {
  var stats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _t = require('i18n-universal').getT();
  var getName = function getName(name) {
    return _t((0, _capitalize3.default)(name));
  };
  return processStatsData({ stats: stats, getName: getName });
}

function processRecipients() {
  var recipients = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return recipients.map(function (recipient) {
    return (0, _extends4.default)({}, recipient, {
      fullName: (0, _strings.concat)(' ', recipient.name, recipient.surname),
      downloadRights: !!recipient.download,
      downloaded: !!recipient.downloaded,
      date: (0, _datetime.formatDateTime)(recipient.uxt),
      expiryDate: (0, _datetime.formatDate)(recipient.recepEd),
      isExpirySoon: (0, _datetime.isExpired)({ time: 0, duration: new Date(recipient.recepEd) })
    });
  });
}

function processCoverageData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if ((0, _isEmpty3.default)(data)) {
    return { stats: {} };
  }

  return {
    stats: {
      played: parseInt(data.played, 10),
      downloads: parseInt(data.downloads, 10)
    },
    playedRecipients: processRecipients(data.playedRecipients),
    notAccessedRecipients: processRecipients(data.notAccessedRecipients)
  };
}

function getPlayStatObject(date) {
  return {
    plays: 0,
    downloads: 0,
    unixDate: date,
    date: new Date(date * 1000),
    dateTime: date
  };
}

function getStartOfDay(date) {
  return (0, _datetime.getMomentDate)(date).startOf('day').unix();
}

function getEmptyPlayStatsPeriod() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var statDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var dates = (statDates.length ? statDates : data).map(function (stat) {
    return getStartOfDay(stat.dateTime);
  });
  if (!dates.length) {
    return [];
  }
  var minDate = Math.min.apply(Math, (0, _toConsumableArray3.default)(dates));
  var maxDate = Math.max.apply(Math, (0, _toConsumableArray3.default)(dates));
  var duration = _moment2.default.duration(maxDate - minDate, 'seconds').days();
  var daysDates = [getPlayStatObject(minDate), getPlayStatObject(maxDate)];
  for (var i = 1; i < duration; i += 1) {
    daysDates.splice(1, 0, getPlayStatObject(getStartOfDay(minDate + i * daySeconds)));
  }
  return daysDates;
}

function processPlayStatsData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dates = arguments[1];

  var daysDates = getEmptyPlayStatsPeriod(data, dates);

  var result = data.reduce(function (accumulator, current) {
    var date = (0, _datetime.getMomentDate)(current.dateTime).startOf('day').unix();
    var item = accumulator[date] || { plays: 0, downloads: 0 };
    var plays = (item.plays || item.play || 0) + (current.play || current.plays || 0); //FIXME: API duct tape
    var downloads = (item.downloads || 0) + current.downloads;
    return (0, _extends4.default)({}, accumulator, (0, _defineProperty3.default)({}, date, {
      plays: plays,
      downloads: downloads,
      unixDate: date,
      date: new Date(date * 1000),
      dateTime: current.dateTime
    }));
  }, (0, _keyBy3.default)(daysDates, 'unixDate'));
  // TODO: remove after merge
  // const afterWeek = Math.round(Date.now() / 1000) + (3600 * 24 * 7);
  // result[afterWeek] = {plays: 5, downloads: 3, unixDate: afterWeek, date: new Date(1000 * afterWeek)};
  var sortedData = (0, _sortBy3.default)((0, _values2.default)(result), 'unixDate');

  return sortedData;
}

function getOrderedCoverageData(_ref4) {
  var data = _ref4.data,
      activeOrder = _ref4.activeOrder,
      order = _ref4.order;

  var processedData = processCoverageData(data);
  processedData.playedRecipients = (0, _ordering2.default)({ data: processedData.playedRecipients, activeOrder: activeOrder, order: order });
  processedData.notAccessedRecipients = (0, _ordering2.default)({ data: processedData.notAccessedRecipients, activeOrder: activeOrder, order: order });
  return processedData;
}

function processProjectInfo(project) {
  return (0, _projects.processProject)(project);
}

function getDetailedTiming(_ref5) {
  var trackTiming = _ref5.trackTiming,
      trackId = _ref5.trackId;

  return (0, _extends4.default)({}, trackTiming, {
    uuid: (0, _uuid2.default)(),
    trackId: trackId,
    durationString: (0, _datetime.secToMinString)(trackTiming.listeningDuration),
    dateString: (0, _datetime.formatDateTime)(trackTiming.date)
  });
}

function formatDetailedTrack(_ref6) {
  var data = _ref6.data;
  var artist = data.artist,
      duration = data.duration,
      filename = data.filename,
      trackId = data.trackId;

  return { artist: artist, duration: duration, filename: filename, trackId: trackId, fullName: (0, _strings.concat)(': ', artist, filename) };
}

function processRecipientDetailedData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var timings = [];
  var tracks = data.map(function (stat) {
    var trackId = stat.trackId,
        _stat$timings = stat.timings,
        trackTimings = _stat$timings === undefined ? [] : _stat$timings;

    trackTimings.map(function (trackTiming) {
      if (trackTiming.listeningDuration) {
        timings.push(getDetailedTiming({ trackTiming: trackTiming, trackId: trackId }));
      }
    });
    return formatDetailedTrack({ data: stat });
  });

  return {
    tracks: (0, _keyBy3.default)(tracks, 'trackId'),
    timings: (0, _reverse3.default)((0, _sortBy3.default)(timings, 'date'))
  };
}

function processTracksDetailsData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var dates = data.reduce(function (accumulator, current) {
    return [].concat((0, _toConsumableArray3.default)(accumulator), (0, _toConsumableArray3.default)(current.stats));
  }, []);

  return data.map(function (trackData) {
    return (0, _extends4.default)({}, trackData, {
      fullName: (0, _strings.concat)(': ', trackData.artist, trackData.trackName),
      stats: processPlayStatsData(trackData.stats, dates)
    });
  });
}

function processRecipientProjects(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === undefined ? [] : _ref7$data,
      activeOrder = _ref7.activeOrder,
      order = _ref7.order;

  var projectsData = data.map(function (project) {
    return (0, _extends4.default)({}, project, project.projectInfo);
  });
  return (0, _ordering2.default)({ data: (0, _projects.processProjects)(projectsData), activeOrder: activeOrder, order: order });
}

function processRecipientProjectsPlayStats(_ref8) {
  var _ref8$data = _ref8.data,
      data = _ref8$data === undefined ? [] : _ref8$data;

  var statsData = data.reduce(function (accumulator, current) {
    return [].concat((0, _toConsumableArray3.default)(accumulator), (0, _toConsumableArray3.default)(current.stats));
  }, []);
  return processPlayStatsData(statsData);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/statistics.js
// module id = 67
// module chunks = 1